export const JSON_API_ACCEPT = "application/vnd.api+json";
export const APPLICATION_JSON_ACCEPT = "application/json";
